"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getZJLPH = exports.getZJL = void 0;
/**
 * 资金流
 */
var web_1 = __importDefault(require("../../config/web"));
var delayparams_1 = require("./delayparams");
//延迟参数
var delayparams = (0, delayparams_1.getDelayparams)();
/**
 * 资金流
 * @param secid
 * @returns
 */
function getZJL(secid) {
    return __awaiter(this, void 0, void 0, function () {
        var data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, $.ajax({
                            url: "".concat(web_1.default.getUrl('quote_api'), "api/qt/stock/fflow/kline/get?cb=?"),
                            type: 'GET',
                            dataType: 'json',
                            data: {
                                secid: secid,
                                ut: web_1.default.getUrl('quote_ut'),
                                fields1: "f1,f2,f3,f7",
                                fields2: "f51,f52,f53,f54,f55,f56,f57,f58,f59,f60,f61,f62,f63,f64,f65",
                                lmt: 0,
                                klt: 1,
                                np: 1,
                                fltt: 2,
                                invt: 2
                            }
                        })];
                case 1:
                    data = _a.sent();
                    if (data === null || data === void 0 ? void 0 : data.data) {
                        return [2 /*return*/, data.data];
                    }
                    return [2 /*return*/, ""];
                case 2:
                    error_1 = _a.sent();
                    return [2 /*return*/, ""];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.getZJL = getZJL;
/**
 * 资金流排行
 * @param secid
 * @returns
 */
function getZJLPH(bkcode) {
    return __awaiter(this, void 0, void 0, function () {
        var data, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, $.ajax({
                            url: "".concat(web_1.default.getUrl('quote_api'), "api/qt/clist/get?cb=?"),
                            type: 'GET',
                            dataType: 'json',
                            data: {
                                ut: web_1.default.getUrl('quote_ut'),
                                fid: "f62",
                                fields: "f12,f13,f14,f62",
                                po: "1",
                                pz: 5,
                                fs: "b:" + bkcode,
                                fltt: 2,
                                invt: 2,
                                wbp2u: delayparams
                            }
                        })];
                case 1:
                    data = _a.sent();
                    if (data === null || data === void 0 ? void 0 : data.data) {
                        return [2 /*return*/, data.data];
                    }
                    return [2 /*return*/, ""];
                case 2:
                    error_2 = _a.sent();
                    return [2 /*return*/, ""];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.getZJLPH = getZJLPH;
